"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.wxMiniprogramInit = exports.wxInit = exports.isQQ = exports.isWeiXin = exports.isMiniprogram = void 0;
var share_1 = require("./share");
var api = __importStar(require("../api/color"));
var wx_1 = require("./wx");
var miniprogramQuery_1 = require("./miniprogramQuery");
var shareInfo = {
    title: share_1.wxShareInfo.title,
    desc: share_1.wxShareInfo.content,
    link: "https://m.healthjd.com/s/",
    imgUrl: share_1.wxShareInfo.imageUrl,
};
function isMiniprogram() {
    //是否是在小程序的webview中
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.includes("miniprogram") ||
        (0, miniprogramQuery_1.getMiniprogramParams)(false).get("miniprogram")) {
        return true;
    }
    else {
        return false;
    }
}
exports.isMiniprogram = isMiniprogram;
function isWeiXin() {
    //细分：纯微信环境，不包含小程序，因为小程序webview走的是h5的登录态
    var ua = window.navigator.userAgent.toLowerCase();
    var miniprogram = isMiniprogram();
    if (miniprogram) {
        return false;
    }
    var micromessengerRes = ua.match(/MicroMessenger/i);
    if (micromessengerRes && micromessengerRes[0] === "micromessenger") {
        return true;
    }
    return false;
}
exports.isWeiXin = isWeiXin;
function isQQ() {
    var ua = window.navigator.userAgent.toLowerCase();
    // eslint-disable-next-line no-useless-escape
    if (/qq\/([\d\.]+)*/.test(ua)) {
        return true;
    }
    else {
        return false;
    }
}
exports.isQQ = isQQ;
function wxInit(paramsShareInfo) {
    return __awaiter(this, void 0, void 0, function () {
        var wx, url, appid;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, wx_1.getwx)()];
                case 1:
                    wx = _a.sent();
                    if (isWeiXin()) {
                        url = window.location.href.split("#")[0];
                        ;
                        appid = paramsShareInfo.appid || 'wx405077c71110dad9';
                        api
                            .getJsTicket({
                            url: encodeURIComponent(url),
                            appid: appid,
                        })
                            .then(function (res) { return __awaiter(_this, void 0, void 0, function () {
                            var data;
                            return __generator(this, function (_a) {
                                data = res.data || {};
                                if (wx) {
                                    wx.config({
                                        debug: false,
                                        appId: data.appid,
                                        timestamp: data.timestamp,
                                        nonceStr: data.nonceStr,
                                        signature: data.signature,
                                        jsApiList: [
                                            "updateAppMessageShareData",
                                            "updateTimelineShareData",
                                            "onMenuShareWeibo",
                                        ],
                                        openTagList: ["wx-open-subscribe"],
                                    });
                                    wx.ready(function () {
                                        wx.updateAppMessageShareData(Object.assign({}, shareInfo, paramsShareInfo));
                                        wx.updateTimelineShareData(Object.assign({}, shareInfo, paramsShareInfo));
                                        wx.onMenuShareWeibo(Object.assign({}, shareInfo, paramsShareInfo));
                                    });
                                    wx.error(function (res) {
                                        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                                        if (window.location.href.indexOf("debugg=11725") > -1) {
                                            alert(JSON.stringify(res));
                                        }
                                    });
                                }
                                return [2 /*return*/];
                            });
                        }); });
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.wxInit = wxInit;
// 微信小程序环境 自定义分享参数设置
function wxMiniprogramInit(paramsShareInfo) {
    return __awaiter(this, void 0, void 0, function () {
        var wx;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isMiniprogram()) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, (0, wx_1.getwx)()];
                case 1:
                    wx = _a.sent();
                    wx.miniProgram.getEnv(function (res) {
                        if (res.miniprogram) {
                            wx.miniProgram.postMessage({ data: paramsShareInfo });
                        }
                    });
                    return [2 /*return*/];
            }
        });
    });
}
exports.wxMiniprogramInit = wxMiniprogramInit;
